import axios from "axios";

const API_URL = process.env.VUE_APP_API_URL;

export { API_URL };

export default {
    namespaced: true,
    state: {
        sitio: null,
        menu: null,
    },
    mutations: {
        SET_SITIO(state, sitio) {
            state.sitio = sitio;
        },
        SET_MENU(state, menu) {
            state.menu = menu;
        },
    },
    actions: {
        async fetchContent({ commit }, sitio) {
            try {
                commit('SET_MENU', null);
                const resp = await axios.get(API_URL, {
                    params: { url: sitio, locale: localStorage.locale || 'es' }
                });
                commit('SET_SITIO', resp.data);
            } catch (error) {
                console.error('Error fetching content:', error);
            }
        },
        async fetchMenu({ commit }, id) {
            try {
                commit('SET_MENU', null);
                const resp = await axios.get(`${API_URL}/menu/${id}`, {
                    params: { locale: localStorage.locale || 'es' }
                });
                commit('SET_MENU', resp.data);
            } catch (error) {
                console.error('Error fetching menu:', error);
            }
        },
    },
    getters: {
        sitio: (state) => state.sitio,
        menu: (state) => state.menu,
    },
};
